export const SUBTITLES_TEMPLATE_WEBVTT_TEXT_VTT = 'web-vtt';

export const SUBTITLES_VERSION_ORDER = [SUBTITLES_TEMPLATE_WEBVTT_TEXT_VTT] as const;

export type AllowedSubtitlesTemplateName = (typeof SUBTITLES_VERSION_ORDER)[number];

export const SUBTITLES_VERSION_LABELS = {
  [SUBTITLES_TEMPLATE_WEBVTT_TEXT_VTT]: 'WebVTT',
} as const;
